import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import DiscrepancyAdd from "./DiscrepancyAdd";
const DiscrepancyLabel = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <DiscrepancyAdd />
      <Footer />
    </>
  );
};

export default DiscrepancyLabel;
